module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("65Hjs"))).then(() => parcelRequire('1iHdE'));